







import "./assignment-list.less";
import Vue from "vue";
import moment from "moment-timezone";
import { mapState, mapGetters } from "vuex";
import AssignmentEditor from "./assignment-editor.vue";
import objective from "@/store/entities/objective";

// eslint-disable-next-line no-undef
let _ = require("lodash");

Vue.component("assignment-editor", AssignmentEditor);

export default Vue.extend({
  name: "AssignmentList",
  components: {
    "assignment-editor": AssignmentEditor,
  },
  props: {
    completed: {
      default: false,
      type: Boolean,
    },
    roleNameResolver: {
      default: null,
      type: Function,
    },
  },
  data() {
    return {
      wrappedDateGroups: [],
      showVideoPlayer: false,
      isLoading: true,
      nodeExpandCache: {},
      notificationText: null,
      dateGroups: [],
    };
  },
  computed: {
    ...mapState("goal", ["loading", "dateFilter", "incompletedCheckpoints", "completedCheckpoints"]),
    ...mapGetters("goal", ["canEditCurrentGoal"]),
    overdueGroups() {
      let context = this as any;
      let groupsByDate = context.dateGroups;

      let result = [];
      let today = moment().startOf("day");

      let overdue = groupsByDate.filter((g) => moment(g.dateString) < today);
      if (overdue.length > 0) {
        result.push({
          title: "Overdue",
          class: "overdue",
          expand: true,
          expandDates: false,
          groupsByDate: overdue,
        });
      }

      let dueToday = groupsByDate.filter((g) => moment(g.dateString).local().isSame(today, "d"));
      if (dueToday.length > 0) {
        result.push({
          title: "Due today",
          class: "due-today",
          expand: true,
          expandDates: false,
          groupsByDate: dueToday,
        });
      }
      //a week from Sunday
      //#Due this week#
      //if today is Saturday (last day of the week), then no "Due this week"
      if (moment().day() <= 5) {
        let tomorrow = moment().startOf("day").add(1, "days");
        let endOfThisWeek = moment().endOf("week");

        let dueThisWeek = groupsByDate.filter((g) => moment(g.dateString) >= tomorrow && moment(g.dateString) <= endOfThisWeek);
        if (dueThisWeek.length > 0) {
          result.push({ title: "Due this week", expand: false, expandDates: false, groupsByDate: dueThisWeek });
        }
      }

      //#Due next week#
      let startOfNextWeek = moment().add(1, "weeks").startOf("week");
      let endOfNextWeek = moment().add(1, "weeks").endOf("week");
      let dueNextWeek = groupsByDate.filter((g) => moment(g.dateString) >= startOfNextWeek && moment(g.dateString) <= endOfNextWeek);
      if (dueNextWeek.length > 0) {
        result.push({ title: "Due next week", expand: false, expandDates: false, groupsByDate: dueNextWeek });
      }

      //#Due in furture#
      let futrue = moment().add(2, "weeks").startOf("week");
      let dueInFutrue = groupsByDate.filter((g) => moment(g.dateString) >= futrue);
      if (dueInFutrue.length > 0) {
        result.push({ title: "Due in future", expand: false, expandDates: false, groupsByDate: dueInFutrue });
      }

      return result;
    },
    treeData() {
      let context = this as any;

      if (context.completed === true) {
        return context.dateGroups
          .sort((a, b) => {
            return a.dateString == b.dateString ? 0 : a.dateString < b.dateString ? 1 : -1;
          })
          .map((group) => {
            let dataKey = `g:${group.title}`;
            return {
              dataKey: dataKey,
              title: context.formatDate(group.dateString),
              expand: context.getNodeExpandFromCache(dataKey, moment().format("YYYY-MM-DD") === group.dateString), //default expand if the date is today
              children: [
                {
                  render: (h, { root, node, data }) => {
                    return context.renderDateGroupContent(h, { root, node, data }, group.objectives);
                  },
                },
              ],
            };
          });
      } else {
        return context.overdueGroups.map((dateGroup) => {
          let dataKey = `g:${dateGroup.title}`;
          return {
            dataKey: dataKey,
            title: dateGroup.title,
            expand: context.getNodeExpandFromCache(dataKey, dateGroup.expand),
            render: (h, { root, node, data }) => {
              return h(
                "span",
                {
                  class: dateGroup.class,
                },
                data.title
              );
            },
            children: dateGroup.groupsByDate.map((group) => {
              let subDataKey = `d:${group.dateString}`;
              return {
                dataKey: subDataKey,
                title: context.formatDate(group.dateString),
                expand: context.getNodeExpandFromCache(subDataKey, dateGroup.expandDates),
                children: [
                  {
                    render: (h, { root, node, data }) => {
                      return context.renderDateGroupContent(h, { root, node, data }, group.objectives);
                    },
                  },
                ],
              };
            }),
          };
        });
      }
    },
  },
  watch: {},
  methods: {
    refresh(trackerId) {
      this.notificationText = this.getNotificationText(trackerId);
      this.dateGroups = this.getDateGroups(trackerId);
    },
    getNotificationText(trackerId) {
      let context = this as any;
      let completedCount = context.completedCheckpoints.filter((cp) => cp.data.checkpoint && cp.data.checkpoint.trackerId === trackerId).length;
      if (context.completed !== true) {
        let incompletedCount = context.incompletedCheckpoints.filter((cp) => cp.data.checkpoint && cp.data.checkpoint.trackerId === trackerId).length;
        if (incompletedCount === 0) {
          return completedCount === 0 ? "Hey There! No objectives have been added yet!" : "Congratulations! All objectives are completed!";
        } else {
          return null;
        }
      } else {
        return completedCount === 0 ? "No completed objectives." : null;
      }
    },
    getDateGroups(trackerId) {
      let context = this as any;
      let checkpoints = context.completed === true ? context.completedCheckpoints : context.incompletedCheckpoints;
      checkpoints = checkpoints
        //.filter(cp => cp.data.checkpoint && cp.data.checkpoint.trackerId === trackerId && new Date(cp.data.checkpoint.trackingDate) <= context.dateFilter)
        .filter((cp) => cp.data.checkpoint && cp.data.checkpoint.trackerId === trackerId)
        .sort((a, b) => {
          return a.priority === b.priority ? 0 : a.priority > b.priority ? 1 : -1;
        });

      return _.chain(checkpoints)
        .groupBy("dateString")
        .map((value, key) => ({
          dateString: key,
          objectives: context.generateGoalGroups(value),
          //treeData: context.generateTreeData(context.generateGoalGroups(value), key),
          paths: _.chain(value)
            .groupBy("path")
            .map((value, key) => ({ name: key, checkpoints: value }))
            .value(),
        }))
        .value()
        .sort((a, b) => {
          return a.dateString == b.dateString ? 0 : a.dateString > b.dateString ? 1 : -1;
        });
    },
    generateGoalGroups(checkpoints) {
      return _.chain(checkpoints)
        .groupBy("objective")
        .map((value, key) => ({
          name: key,
          priority: value[0].objectivePriority,
          checkpoints: value.sort((a, b) => {
            return a.data.checkpoint.targetUserName == b.data.checkpoint.targetUserName ? 0 : a.data.checkpoint.targetUserName > b.data.checkpoint.targetUserName ? -1 : 1;
          }),
        }))
        .value()
        .sort((a, b) => {
          return a.priority == b.priority ? 0 : a.priority > b.priority ? 1 : -1;
        });
    },
    renderDateGroupContent(h, { root, node, data }, objectives) {
      let context = this as any;
      let editors = [
        ...objectives.flatMap((objective) => [
          ...objective.checkpoints.map((checkpoint) => {
            return h("assignment-editor", {
              props: {
                assignment: checkpoint.data,
                roleNameResolver: context.roleNameResolver,
              },
              on: {
                "open-video": context.handleVideoClick,
                "edit-objective": function (objectiveId) {
                  context.$emit("edit", null, objectiveId);
                },
              },
            });
          }),
        ]),
      ];

      return h("div", { class: "assignment-node-wrap" }, editors);
    },
    generateTreeData(objectiveGroups, dateString) {
      let context = this as any;
      return objectiveGroups.map((objective) => {
        let firstCheckpointData = objective.checkpoints[0].data;
        let dataKey = `${dateString}:${objective.priority}:${objective.name}`;
        let expand = context.getNodeExpandFromCache(dataKey, true);
        return {
          dataKey: dataKey,
          title: objective.name,
          expand: expand,
          render: (h, { root, node, data }) => {
            const titleElement = context.canEditCurrentGoal
              ? h(
                  "a",
                  {
                    on: {
                      click: function () {
                        context.$emit("edit", null, firstCheckpointData.objectiveId);
                      },
                    },
                  },
                  data.title
                )
              : data.title;
            return h("span", {}, [titleElement, context.createTrackingTimeElement(context, h, objective.checkpoints)]);
          },
          children: [
            {
              expand: true,
              render: (h, { root, node, data }) => {
                let attachments = firstCheckpointData && firstCheckpointData.attachments ? JSON.parse(firstCheckpointData.attachments) : [];
                return h("div", { class: "assignment-node-wrap" }, [
                  h("p", firstCheckpointData.trackingQuestion),
                  ...attachments.map((attachment) => {
                    return context.createAttachmentButton(context, h, attachment);
                  }),
                  ...objective.checkpoints.map((checkpoint) => {
                    return h("assignment-editor", {
                      props: {
                        objective: objective,
                        assignment: checkpoint.data,
                        roleNameResolver: context.roleNameResolver,
                      },
                      on: {
                        "open-video": context.handleVideoClick,
                        "edit-objective": function (objectiveId) {
                          context.$emit("edit", null, objectiveId);
                        },
                      },
                    });
                  }),
                ]);
              },
            },
          ],
        };
      });
    },
    createAttachmentButton(context, h, attachment) {
      let button =
        attachment.type == 3
          ? h(
              "Button",
              {
                props: { to: attachment.link, target: "_blank" },
                style: { padding: 0, height: "24px", margin: "0 4px 6px 0" },
              },
              [h("div", { attrs: { class: "menu-icon menu-icon-weblink" } })]
            )
          : attachment.type == 2
          ? h(
              "Button",
              {
                props: { to: attachment.link, target: "_blank" },
                style: { padding: 0, height: "24px", margin: "0 4px 6px 0" },
              },
              [h("div", { attrs: { class: "menu-icon menu-icon-document" } })]
            )
          : h(
              "Button",
              {
                style: { padding: 0, height: "24px", margin: "0 4px 6px 0" },
                on: {
                  click: () => {
                    context.handleVideoClick(attachment.type, attachment.link);
                  },
                },
              },
              [h("div", { attrs: { class: "menu-icon menu-icon-video" } })]
            );
      return h("Tooltip", { props: { content: attachment.title, placement: "top" } }, [button]);
    },
    createTrackingTimeElement(context, h, checkpoints) {
      let completed = true;
      let className = "completed";

      checkpoints.forEach((checkpoint) => {
        if (!checkpoint.data.checkpoint.value) {
          completed = false;
          className = moment(checkpoint.data.checkpoint.trackingDate) < moment() ? "overdue" : "due-in-future";

          return false;
        }
      });

      let firstCheckpointData = checkpoints[0].data;
      let trackingDate = moment(firstCheckpointData.checkpoint.trackingDate).format("hh:mm a");

      return h(
        "span",
        {
          class: className,
        },
        ` (${trackingDate})`
      );
    },
    handleNodeToggleExpand(node) {
      if (node.dataKey) {
        this.nodeExpandCache[node.dataKey] = node.expand;
      }
    },
    getNodeExpandFromCache(dataKey, defaultValue) {
      return this.nodeExpandCache[dataKey] === undefined ? defaultValue : this.nodeExpandCache[dataKey];
    },
    handleObjectiveClick(objective) {
      this.$emit("objective-click", objective);
    },
    handleVideoClick(type, url) {
      this.$emit("play-video", type, url);
    },
    formatDate(dateString) {
      return moment(dateString).format("ddd, MMM D, YYYY");
    },
  },
});
